import usePending from '@anm/hooks/usePending';
import { useSelector } from 'react-redux';

import { appSumoSelectors } from '../../../../store/modules/appSumo';
import { subscriptionSelectors } from '../../../../store/modules/subscription';
import { userSelectors } from '../../../../store/modules/user';

const useCurrentPlanPending = () => {
  const isUserPending = useSelector(userSelectors.selectUserPending);
  const isHistoryPending = useSelector(subscriptionSelectors.selectHistoryPending);
  const isAppSumoPending = useSelector(appSumoSelectors.selectUpgradePending);
  const isPending = usePending(isAppSumoPending || isUserPending || isHistoryPending);

  return isPending;
};

export default useCurrentPlanPending;
